/**
 * Product benefits: accordion tabs sync with media panels (video + overlay).
 */
(function () {
  class ProductBenefits extends HTMLElement {
    connectedCallback() {
      this._tabs = Array.from(this.querySelectorAll('[data-benefit-tab]'));
      this._panels = Array.from(this.querySelectorAll('[data-benefit-panel]'));
      if (!this._tabs.length) return;

      this._tabs.forEach((tab, index) => {
        const toggle = tab.querySelector('[data-benefit-tab-toggle]');
        if (!toggle) return;
        toggle.addEventListener('click', () => this.select(index));
      });

      const initial = Math.max(
        0,
        this._tabs.findIndex((tab) => tab.classList.contains('is-active'))
      );

      this.classList.add('product-benefits--no-transition');
      this.select(initial, false);
      this._bindVideoToggles();
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.classList.remove('product-benefits--no-transition'));
      });

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          const tab = event.target.closest('[data-benefit-tab]');
          if (!tab || !this.contains(tab)) return;
          const index = parseInt(tab.getAttribute('data-tab-index'), 10);
          if (!Number.isNaN(index)) this.select(index);
        });
      }
    }

    select(index, dispatch = true) {
      this._tabs.forEach((tab, i) => {
        const isActive = i === index;
        const toggle = tab.querySelector('[data-benefit-tab-toggle]');
        const panel = tab.querySelector('[data-benefit-tab-panel]');

        tab.classList.toggle('is-active', isActive);
        if (toggle) toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        if (panel) panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      this._panels.forEach((panel) => {
        const panelIndex = parseInt(panel.getAttribute('data-tab-index'), 10);
        const isActive = panelIndex === index;
        panel.hidden = !isActive;

        const video = panel.querySelector('video');
        if (video && !isActive) {
          video.pause();
        }
      });

      this.querySelectorAll('[data-benefit-media-slot]').forEach((slot) => {
        const slotIndex = parseInt(slot.getAttribute('data-tab-index'), 10);
        slot.hidden = slotIndex !== index;
      });

      if (dispatch) {
        this.dispatchEvent(
          new CustomEvent('product-benefits:change', {
            bubbles: true,
            detail: { index },
          })
        );
      }
    }

    _bindVideoToggles() {
      this.querySelectorAll('video-media').forEach((videoMedia) => {
        if (videoMedia.dataset.benefitVideoToggleBound === 'true') return;
        videoMedia.dataset.benefitVideoToggleBound = 'true';

        videoMedia.addEventListener(
          'click',
          (event) => {
            const video = videoMedia.querySelector('video');
            if (!video || this._isVideoControlsClick(video, event.clientY)) return;

            // Stop native video click-to-toggle; we handle play/pause once here.
            event.preventDefault();
            event.stopPropagation();

            if (videoMedia.playing) {
              videoMedia.pause();
            } else {
              videoMedia.play();
            }
          },
          { capture: true }
        );
      });
    }

    _isVideoControlsClick(video, clientY) {
      const rect = video.getBoundingClientRect();
      const controlsHeight = Math.min(56, rect.height * 0.2);
      return clientY > rect.bottom - controlsHeight;
    }
  }

  if (!window.customElements.get('product-benefits')) {
    window.customElements.define('product-benefits', ProductBenefits);
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('product-benefits');
    if (root && typeof root.select === 'function') {
      const initial = Math.max(
        0,
        Array.from(root.querySelectorAll('[data-benefit-tab]')).findIndex((tab) =>
          tab.classList.contains('is-active')
        )
      );
      root.classList.add('product-benefits--no-transition');
      root.select(initial, false);
      if (typeof root._bindVideoToggles === 'function') {
        root._bindVideoToggles();
      }
      requestAnimationFrame(() => {
        requestAnimationFrame(() => root.classList.remove('product-benefits--no-transition'));
      });
    }
  });
})();
